// Display names for audit categories and events. Colour only marks a state
// (a failure), never a category — categories read as neutral chips.

export const CATEGORY_LABELS = {
  auth: 'Sign-in',
  security: 'Security',
  permission: 'Users & permissions',
  setting: 'Settings',
  export: 'Export & download',
  data: 'Business change',
  system: 'System',
};

export const CATEGORY_OPTIONS = Object.entries(CATEGORY_LABELS).map(([value, label]) => ({ value, label }));

const EVENT_LABELS = {
  'auth.login': 'Signed in',
  'auth.login_failed': 'Sign-in failed',
  'auth.logout': 'Signed out',
  'auth.password_reset': 'Password reset',
  'impersonation.start': 'View as user — started',
  'impersonation.stop': 'View as user — ended',
  'security.session_revoked': 'Session signed out by admin',
  'security.token_reuse': 'Stolen token suspected',
  'security.rate_limit_cleared': 'Rate limit lifted',
};

const VERBS = { export: 'Exported', print: 'Printed', download: 'Downloaded', view: 'Viewed' };

const humanize = (text) => String(text || '')
  .replace(/[._]/g, ' ')
  .replace(/\s+/g, ' ')
  .trim()
  .replace(/^\w/, (c) => c.toUpperCase());

// "export.project" → "Exported project", "role.assign_user" → "Role · Assign user".
export const eventLabel = (action) => {
  if (!action) return '—';
  if (EVENT_LABELS[action]) return EVENT_LABELS[action];

  const [head, ...rest] = action.split('.');
  if (VERBS[head] && rest.length) return `${VERBS[head]} ${humanize(rest.join(' '))}`.replace(/ (\w)/, (m) => m.toLowerCase());
  if (rest.length) return `${humanize(head)} · ${humanize(rest.join(' '))}`;
  return humanize(action);
};

export const categoryLabel = (category) => CATEGORY_LABELS[category] || humanize(category);

// Browser + OS from a user agent, for the table cell. The full string is in the drawer.
export const deviceLabel = (ua) => {
  if (!ua) return '';
  const browser = (ua.match(/(Edg|OPR|Chrome|Firefox|Safari)\/[\d.]+/) || [])[1];
  const os = (ua.match(/(Windows|Mac OS X|Android|iPhone|iPad|Linux)/) || [])[1];
  const names = { Edg: 'Edge', OPR: 'Opera', 'Mac OS X': 'macOS' };
  return [names[browser] || browser, names[os] || os].filter(Boolean).join(' · ') || 'Unknown device';
};
